<script setup lang="ts">
import { onMounted } from 'vue';
import { vueComponentToggler } from '../../../modules/toggler_wp';

defineProps<{
  heading: string;
  content: string;
}>();

onMounted(() => {
  vueComponentToggler();
});
</script>

<template>
  <div class="checkout-login-cta layout-new-checkout__element">
    <h2>{{ heading }}</h2>
    <p>{{ content }}</p>
    <button
      class="btn btn--profile btn--smaller checkout-login-cta__button _js-vue-component-toggler"
      data-togglewhat="login"
      aria-controls="login"
    >
      {{ $t("loginOrRegister") }}
    </button>
  </div>
</template>
